import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Printer } from '@one-thd/sui-icons';
import { useDigitalDataStore } from '../../../store';
import { useDesignStore } from '../../../store/design/context';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

const PrintDesign = () => {
  const trackPrintStackSummaryEvent = useDigitalDataStore((state) => state.trackPrintStackSummaryEvent);
  const design = useDesignStore((state) => state.design);
  const clickPrint = () => {
    window.print();
    trackPrintStackSummaryEvent();
    logNewRelicCustom(NEW_RELIC_EVENTS.PRINT_DESIGN, design);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      type="button"
      onClick={() => clickPrint()}
      className="sui-flex sui-flex-row sui-items-start sui-pt-4 sui-pl-4"
    >
      <span className="sui-pr-1">
        <Printer color="brand" />
      </span>
      <Typography color="primary" variant="body-xs" weight="bold">
        Print
      </Typography>
    </div>
  );
};

export default PrintDesign;
